import http from '@/service/http'
import { ROOT_SIMULATOR } from './urlConfig'

export type TutorialContentType = 'PDF' | 'VIDEO'
export type TutorialVideoSource = 'SELF' | 'BILIBILI'

export interface TutorialCard {
    id: string
    code: string
    name: string
    sort: number
    contentType: TutorialContentType
    videoSource: TutorialVideoSource | null
    contentUrl: string
    coverUrl: string | null
}

export interface TutorialContentCategory {
    id: string
    code: string
    name: string
    sort: number
    tutorials: TutorialCard[]
}

export interface TutorialPrimaryCategory {
    id: string
    code: string
    name: string
    sort: number
    contentCategories: TutorialContentCategory[]
}

export interface TutorialCenterResponse {
    primaryCategories: TutorialPrimaryCategory[]
}

interface TutorialCenterResult {
    code: number | string
    data: TutorialCenterResponse
    message: string
}

// 获取教程中心分类及教程列表
export const getTutorialCenterList = (): Promise<TutorialCenterResult> => {
    return http.get<TutorialCenterResponse>(ROOT_SIMULATOR + '/api/tutorialCenter/list')
}
